import { configureStore } from "@reduxjs/toolkit";
import LoginReducer from "./redux/reducers/auth-reducer/LoginReducer";


const appstore = configureStore({
    reducer: {
        LoginSlice: LoginReducer,
    },

    middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }),

});

export type RootState = ReturnType<typeof appstore.getState>;
export type AppDispatch = typeof appstore.dispatch;
 
export default appstore;






